/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react'
import { DataSource } from '.';
import { HistoricalReportData } from '../../../types/reportData';
import GHGEmissions from './data/GHGEmissions';
import GHGEmissionsIntensity from './data/GHGEmissionsIntensity';
import EnergyConsumption from './data/EnergyConsumption';
import WaterConsumption from './data/WaterConsumption';
import Social from './data/Social';
import Governance from './data/Governance';
import { VisibilityStatus } from '../../../types/download';

export const CHART_DEFAULTS = {
  OPTIONS: {
    colors: ['#A6CFE5', '#D6F5DF', '#1A5A87'],
    pieSliceTextStyle: {
      color: '#0c3866',
    },
    legend: {
      position: 'top'
    },
    chartArea: {
      top: 40,
      bottom: 20,
      left: 20,
      right: 20,
    },
    titleTextStyle: {
      color: 'a1a3a4'
    }
  }
};

export interface GenerateChartsProps {
  updateData?: (key: string, data: DataSource) => void;
  questionData: HistoricalReportData[];
  visibility: VisibilityStatus;
}

const GenerateCharts = React.memo((props: GenerateChartsProps) => {
  return <div
    style={{ height: 0, width: 0, overflow: 'hidden' }}
  >
    <GHGEmissions {...props} />
    <GHGEmissionsIntensity {...props} />
    <EnergyConsumption {...props} />
    <WaterConsumption {...props} />
    <Social {...props} />
    <Governance {...props} />
  </div>
})

export default GenerateCharts;
